"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function dash(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M14.3228 5.9209H8.86583L8.41432 8.44615L13.3358 8.45365C15.7591 8.45365 16.4783 9.3334 16.4551 10.7936C16.4446 11.5422 16.1183 12.8082 15.9803 13.2162C15.6076 14.3112 14.8396 15.5576 11.9611 15.5539L7.17757 15.5509L6.72607 18.0792H12.1688C14.0881 18.0792 14.9056 17.8549 15.7688 17.4567C17.6843 16.5732 18.8251 14.6809 19.2833 12.2112C19.9628 8.53615 19.1153 5.9209 14.3221 5.9209H14.3228Z", fill: color }),
        React.createElement("path", { d: "M11.8635 11.7664C12.0413 11.0276 12.0975 10.7314 12.0975 10.7314H6.51304C5.08504 10.7314 4.88104 11.6614 4.74529 12.2239C4.56754 12.9596 4.51129 13.2596 4.51129 13.2596H10.0965C11.5238 13.2596 11.7278 12.3296 11.8635 11.7664Z", fill: color }));
}
exports["default"] = dash;
//# sourceMappingURL=dash.js.map